import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { isSerialNumberValid } from './../../../../../../common/validation';
import { actions, selectors } from './../../../../../../modules/customer/profile/hardwareProducts';
import HardwareList from './HardwareList';

const anySelectedHardware = (data) => (data.hardwareList.length > 0 || data.cardList.length > 0);
const AddHardwareStep3 = ({addHardwareFormData}) => {
    return (
        <div className="col-xs-12 addHardware">
            <div className="row">
                <div className="col-md-4 col-xs-12">
                    <h2>Sammendrag:</h2>
                    <div className="row">
                        <div className="col-xs-12">
                            Mottaker og evt kort blir lagt til på kundeforholdet i ICC. Hvis kunden har Rikspakken eller et Premium produkt legges det til abonnement på dette kortet.
                            <br />
                            <b>NB: </b>
                            hvis kunden har mer enn 4 kort og boks så legges kun utstyret til. Hvis kunden skal ha abonnement på nytt kort så må det legges til i ICC eller linkes om fra tidligere kort.
                            <br />Trykk OK for å bekrefte
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-12 ">
                    {anySelectedHardware(addHardwareFormData) &&
                        <div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <h2>Box</h2>
                                    <div className="hardwareProduct col-xs-10">
                                        <div className="row">
                                            <HardwareList hardwareList={addHardwareFormData.hardwareList} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <h2>Programkort</h2>
                                    <div className="hardwareProduct col-xs-10">
                                        <div className="row">
                                            <HardwareList hardwareList={addHardwareFormData.cardList} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {!anySelectedHardware(addHardwareFormData) &&
                        <div className="text-warning">
                            <h2>Utstyr ikke valgt,</h2>
                            <span>gå tilbake å legg til utstyr</span>
                        </div>
                    }
                </div>
                <div className="col-md-4 col-xs-12">
                </div>
            </div>
        </div >
    )
};

AddHardwareStep3.propTypes = {
}

const mapStateToProps = createStructuredSelector({
    addHardwareFormData: selectors.addHardwareFormData,
});

export default connect(mapStateToProps)(AddHardwareStep3)